<aside class="block__left-side-panel">
    <div class="text-items">
        <h1 class="text-items__title">
            {{'CHANGE_PASSWORD_TITLE' | translate}}
        </h1>
        <p class="text-items__description">
            {{'CHANGE_PASSWORD_INFO' | translate}}
        </p>
    </div>
</aside>
